<div class="overlay">
    <div class="modal">
        <h2>Something went wrong</h2>
        <!-- add best practice for credit card declined, sorry, wait 1-2 minutes and try your card again.-->
        <p class="alert-overlay-text">Sorry—we had trouble processing your payment. We apologize for the inconvenience. Please wait 1–2 minutes, then click the button below to try again.</p>
        <button class="btn btn-primary" (click)="remediateIssue()">Confirm</button>
    </div>
</div>